import { axios } from '@/utils/request'

export function InfoMainWebPage(parameter) {
  return axios({
    url: '/InfoMain/web/page',
    method: 'get',
    params: parameter
  })
}
// 新闻中心消息文本
export function InfoMainWebDetail(parameter) {
  return axios({
    url: '/InfoMain/web/detail',
    method: 'get',
    params: parameter
  })
}
/** 新闻热点 */
export function InfoMainWebHits(parameter) {
  return axios({
    url: '/InfoMain/web/hits',
    method: 'get',
    params: parameter
  })
}

/**
 * 获取乡村简介 给地图提供数据
 *
 * @author lifengchao
 */
 export function getInfoForMap(parameter) {
  return axios({
    url: '/InfoMain/getInfoForMap',
    method: 'get',
    params: parameter
  })
}

/**
 * 获取产权发布信息列表
 * @param {parameter} parameter 
 * @returns 
 */
export function CQFBPageList(parameter){
  return axios({
    url: '/InfoMain/web/CQFBPageList',
    method: 'get',
    params: parameter
  })
}
